
import { ListDataSource } from "@/data/List/ListDataSource";
import { Vue, Component, Watch } from "vue-property-decorator";
import ObjectDataTable from "@/components/helpers/object-data-table.vue";
import {
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiMinus,
  mdiPen,
  mdiPlus,
  mdiPlusCircleOutline,
  mdiTrashCan,
} from "@mdi/js";
import editor from "./editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import _ from "lodash";
import { remove } from "@/cms-services/helpers";
import { Filter } from "@/cms-services/filter";
import axios from "axios";

@Component({
  mixins: [editor],
  components: { ObjectDataTable },
})
export default class ProductLinkInlineEditor extends Vue {
  dataSource!: ObjectDataSource;
  searchTimer: any = null;
  dialog: boolean = false;
  searchText: string = "";
  filterText: string = "";
  loaded: boolean = false;
  itemsCopy: any = [];
  icons: any = {
    plus: mdiPlus,
    minus: mdiMinus,
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
  };

  headers: any[] = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Подпись",
      value: "caption",
      sortable: true,
    },
    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  authorDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: "author",
  });

  linkedAuthorDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: "author",
  });
  componentLinkSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 1000 },
    className: "ComponentLink",
  });

  $message: any;

  // Пустые элементы в authors (сервер не дозагрузил автора) не должны ронять редактор.
  get linkedAuthors(): any[] {
    return (this.dataSource.model?.authors ?? []).filter((c: any) => c);
  }

  updateAuthors() {
    let sourceItems = Array.from([...this.authorDataSource.items]);

    for (const author of sourceItems) {
      const exists = this.linkedAuthors.some(
        (c: any) => c.id == author.id,
      );
      if (exists) {
        remove(this.authorDataSource.items, (c: any) => c.id == author.id);
      }
    }
    this.linkedAuthorDataSource.items = this.linkedAuthors.map(
      (cf: any) => this.itemsCopy.find((f: any) => f.id == cf.id),
    )
        .filter(f=>f);
    console.log("linkedAuthorDataSource.items: ",this.linkedAuthorDataSource.items)
  }

  filterLinkedauthor() {
    this.updateAuthors();
    if (!this.filterText) return;
    const re = new RegExp(this.filterText, "gi");
    this.linkedAuthorDataSource.items =
      this.linkedAuthorDataSource.items.filter((c: any) =>
        c.caption.match(re),
      );
  }

  async created() {
    await this.authorDataSource.get();
    this.itemsCopy = _.cloneDeep(this.authorDataSource.items);
    console.log("this.itemsCopy: ",this.itemsCopy)

    this.linkedAuthorDataSource.metadata = this.authorDataSource.metadata;
    this.linkedAuthorDataSource.total = this.linkedAuthors.length;
    this.componentLinkSource.items = this.linkedAuthors;
    console.log("this.componentLinkSource.items: ",this.componentLinkSource.items)
    this.updateAuthors();
    this.loaded = true;
  }

  async add(item: any) {
    await this.componentLinkSource.add({
      LinkedComponentId : item.id,
      ComponentId : this.dataSource.id,
    });

    await this.dataSource.get();
    this.updateAuthors();
    this.linkedAuthorDataSource.total =
      this.linkedAuthorDataSource.items.length;
    this.$message("Успешно добавлено");
  }

  async remove(item: any) {
    const cf = this.dataSource.model?.authors?.find(
      (c: any) => c.id == item.id,
    );

    await axios.post(`${this.componentLinkSource.baseUrl}/delete`, { componentId:this.dataSource.model?.id, linkedComponentId:  item.id });
    remove(this.linkedAuthorDataSource.items, (c: any) => c.id === item.id);
    this.authorDataSource.items.unshift(item);
    this.linkedAuthorDataSource.total =
      this.linkedAuthorDataSource.items.length;

    this.$message("Успешно удалено");
  }

  @Watch("searchText")
  debounceSearch(value: string) {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.authorDataSource.config.filter = JSON.stringify([
        new Filter("searchText", value),
      ]);
      await this.authorDataSource.get();
      this.updateAuthors();
    }, 1000);
  }
}
